// Pure presentation decisions for the kiosk hub's due list (operaitor/backend#2619),
// kept out of the component so they can be tested without a renderer.

import type { KioskDueList, KioskV2DueOption } from '../../api/bookingApi';

export type DueSection =
  | { kind: 'loading' }
  // The policy answered and something is owed.
  | { kind: 'list'; items: KioskV2DueOption[] }
  // Nothing is owed, or no policy was evaluated and no menu is available.
  | { kind: 'none' }
  // The due list could not be read and there is no menu: ask the front desk.
  | { kind: 'unavailable' }
  // `not_evaluated` / `unavailable` with a menu: show it and make no claim.
  | { kind: 'hidden' };

export function dueSection(due: KioskDueList | null, hasMenu: boolean): DueSection {
  if (due === null) return { kind: 'loading' };
  if (due.due_state !== 'evaluated') {
    if (hasMenu) return { kind: 'hidden' };
    return { kind: due.due_state === 'unavailable' ? 'unavailable' : 'none' };
  }
  return due.due.length > 0 ? { kind: 'list', items: due.due } : { kind: 'none' };
}

// 409 `kiosk_obligation_not_due`: the server re-decided and the key is no longer in
// the list (completed meanwhile, or the practice's rules changed). The hub answers
// by re-reading the list rather than guessing.
export function isObligationNotDue(err: unknown): boolean {
  const e = err as { status?: number; data?: { detail?: unknown } } | null;
  return e?.status === 409 && e?.data?.detail === 'kiosk_obligation_not_due';
}

export const DUE_REFRESH_FAILED: KioskDueList = {
  due_state: 'unavailable',
  due_reason: 'refresh_failed',
  due: [],
};
